import React, { useState, useRef } from "react";
import axios from "axios";
import { useUser } from "../context/useUser";

const url = process.env.REACT_APP_BACKEND_CONNECTION;

export default function AdminImportStaircases() {
  const { user } = useUser();
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setStatus("Please select a CSV file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setStatus("");

    try {
      const response = await axios.post(
        `${url}/admin/housing-company/import-staircases`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      let message = response.data.message || "Import completed.";

      if (response.data.createdTypes?.length > 0) {
        message += `\nCreated staircase types:\n${response.data.createdTypes
          .map((t) => `${t.staircase_type} (${t.housing_company})`)
          .join("\n")}`;
      }

      if (response.data.createdStaircases?.length > 0) {
        message += `\nCreated staircases:\n${response.data.createdStaircases
          .map(
            (s) =>
              `${s.staircase_type} (${s.housing_company})`
          )
          .join("\n")}`;
      }

      if (response.data.skipped?.length > 0) {
        message += `\nSkipped (already exist):\n${response.data.skipped
          .map(
            (s) =>
              `${s.staircase_type} (${s.housing_company})`
          )
          .join("\n")}`;
      }

      if (response.data.errors?.length > 0) {
        message += `\nErrors:\n${response.data.errors
          .map((e) => `${e.error} — ${JSON.stringify(e.row)}`)
          .join("\n")}`;
      }

      setStatus(message);
    } catch (error) {
      console.error("Import error:", error);
      setStatus(
        error.response?.data?.error || "Something went wrong during import."
      );
    } finally {
      setLoading(false);
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  return (
    <div className="default-container">
      <div className="default-box">
        <h2 className="default-title">
          <i className="fas fa-building" /> Lisää Portaat
        </h2>

        <form onSubmit={handleSubmit} className="admin-form">
          <label className="admin-label">
            <i className="fas fa-file-csv" /> Valitse CSV Tiedosto:
          </label>
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={(e) => setFile(e.target.files[0])}
            className="admin-input"
          />

          <button className="default-button" type="submit" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Ladataan...
              </>
            ) : (
              <>
                <i className="fas fa-upload" /> Lataa
              </>
            )}
          </button>
        </form>

        {status && (
          <pre
            className={`status-text ${
              status.toLowerCase().includes("error") ||
              status.toLowerCase().includes("wrong") ||
              status.toLowerCase().includes("please")
                ? "error"
                : "success"
            }`}
            style={{ whiteSpace: "pre-wrap", textAlign: "left", marginTop: "1rem" }}
          >
            <i
              className={
                status.toLowerCase().includes("error") ||
                status.toLowerCase().includes("wrong") ||
                status.toLowerCase().includes("please")
                  ? "fas fa-exclamation-circle"
                  : "fas fa-check-circle"
              }
            />{" "}
            {status}
          </pre>
        )}
      </div>
    </div>
  );
}